export default {"src":"/_next/static/media/spotify.e1653576.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};